import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BlogData from "../../data/blog/BlogData.json";
import BlogGridTwo from './BlogGridTwo';
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import ReactPaginate from 'react-paginate';

const allBlogData = BlogData;
const blogsPerPage = 9;
export const pageCount = Math.ceil(allBlogData.length / blogsPerPage);

const BlogGridSimple = () => {

    const [blogs] = useState(allBlogData);
    const { pageNum } = useParams();
    const navigate = useNavigate();

    // /blogs/page/N is 1-indexed in the URL, 0-indexed internally for react-paginate.
    const requestedPage = parseInt(pageNum, 10);
    const pageNumber = Number.isInteger(requestedPage) && requestedPage >= 1 && requestedPage <= pageCount
        ? requestedPage - 1
        : 0;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber]);

    const pageVisited = pageNumber * blogsPerPage;

    const changePage = ({ selected }) => {
        navigate(selected === 0 ? "/blogs" : `/blogs/page/${selected + 1}`);
    }

    return (
        <>
            <div className="row row--30">
                <BlogGridTwo data={blogs.slice(pageVisited, pageVisited + blogsPerPage)} colSize="col-lg-4 col-md-6" eagerCount={3} />
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <ReactPaginate
                        previousLabel={<FaArrowLeft />}
                        nextLabel={<FaArrowRight />}
                        pageCount={pageCount}
                        forcePage={pageNumber}
                        onPageChange={changePage}
                        hrefBuilder={(page) => {
                            const clamped = Math.min(Math.max(page, 1), pageCount);
                            return clamped <= 1 ? "/blogs" : `/blogs/page/${clamped}`;
                        }}
                        hrefAllControls={true}
                        containerClassName={"pagination justify-content-center"}
                        previousLinkClassName={"prev"}
                        nextLinkClassName={"next"}
                        disabledClassName={"disabled"}
                        activeClassName={"current"}
                    />
                </div>
            </div>
        </>
    )
}

export default BlogGridSimple;
